import { qboProvider, buildConnectUrl, getConnection, disconnect } from './qbo/index.js'

export interface IntegrationEntry {
  id: string
  name: string
  iconColor: string
  startOAuth: (storeId: string, invoiceNumber: string) => string
  getConnectionStatus: (realmId: string) => Promise<{ connected: boolean; company?: { companyName?: string; baseCurrency?: string; email?: string } }>
  disconnect: (realmId: string) => Promise<void>
}

interface RegistryEntry {
  provider: { id: string; name: string; iconColor: string }
  startOAuth: (storeId: string, invoiceNumber: string) => string
  getConnectionStatus: (realmId: string) => Promise<{ connected: boolean; company?: { companyName?: string; baseCurrency?: string; email?: string } }>
  disconnect: (realmId: string) => Promise<void>
}

const registry: Record<string, RegistryEntry> = {}

export function getIntegration(providerId: string): IntegrationEntry | null {
  const key = providerId?.toUpperCase()
  const entry = registry[key]
  if (!entry) return null

  return {
    id: entry.provider.id,
    name: entry.provider.name,
    iconColor: entry.provider.iconColor,
    startOAuth: entry.startOAuth,
    getConnectionStatus: entry.getConnectionStatus,
    disconnect: entry.disconnect,
  }
}

export function getAllIntegrations(): { id: string; name: string; iconColor: string }[] {
  return Object.values(registry).map(e => ({
    id: e.provider.id,
    name: e.provider.name,
    iconColor: e.provider.iconColor,
  }))
}

export function isRegisteredProvider(providerId: string): boolean {
  return registry[providerId?.toUpperCase()] != null
}

async function registerQbo() {
  registry['QUICKBOOKS'] = {
    provider: qboProvider,
    startOAuth: buildConnectUrl,
    getConnectionStatus: getConnection,
    disconnect,
  }
}

registerQbo()